import React from 'react';
import { FiTruck, FiAlertTriangle, FiBox, FiTool } from 'react-icons/fi';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../contexts/LanguageContext';

type ServiceItemProps = {
    icon: React.ReactNode;
    title: string;
    description: string[];
};

const ServiceItem: React.FC<ServiceItemProps> = ({ icon, title, description }) => {
    return (
        <div className="flex items-start mb-6">
            <div className="bg-[#29519f] p-4 rounded-lg mr-5 flex items-center justify-center">
                {icon}
            </div>
            <div>
                <h2 className="text-2xl font-bold text-white">{title}</h2>
                <ul className="text-[#8896ab] mt-2 list-disc list-inside">
                    {description.map((item, index) => (
                        <li key={index} className="mt-1">
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const Services: React.FC = () => {
    const { tString, tArray } = useLanguage();
    
    return (
        <section
            className="w-screen px-16 py-16"
            style={{
                backgroundColor: '#2a3342',
                backgroundImage: `
                    radial-gradient(ellipse 80% 60% at center, transparent 0%, #2a3342 90%),
                    url('/images/light_pattern.png')
                    `,
                backgroundRepeat: 'repeat',
                backgroundSize: 'auto',
            }}
        >
            <div id="services" className="scroll-mt-40 flex flex-col-reverse md:flex-row items-center justify-center gap-14 max-w-7xl mx-auto">
                <div className="w-full md:w-1/2">
                <ScrollReveal direction="left" delay={0.2} duration={0.8}>
                    <img
                        src="/images/services.png"
                        alt="Servicio de transporte Montelo"
                        className="w-[550px] h-[300px] md:h-[500px] object-cover rounded-xl"
                    />
                    </ScrollReveal>
                </div>

                <div className="w-full md:w-1/2 text-left">
                    <ScrollReveal direction="up" delay={0.3} duration={0.8}>
                        <h1 className="text-4xl font-bold text-white mb-4">
                            {tString('services.title')}<span className="text-[#29519f]">.</span>
                        </h1>
                    </ScrollReveal>
                    <ScrollReveal direction="up" delay={0.4} duration={0.8}>
                        <p className="text-[#8896ab] mb-8">
                            {tString('services.description')}
                        </p>
                    </ScrollReveal>

                    <ScrollReveal direction="right" delay={0.5} duration={0.8}>
                        <ServiceItem
                            icon={<FiTruck className="text-white text-xl" />}
                            title={tString('services.items.transport.title')}
                            description={tArray('services.items.transport.description')}
                        />
                    </ScrollReveal>
                    <ScrollReveal direction="right" delay={0.6} duration={0.8}>
                        <ServiceItem
                            icon={<FiAlertTriangle className="text-white text-xl" />}
                            title={tString('services.items.specialized.title')}
                            description={tArray('services.items.specialized.description')}
                        />
                    </ScrollReveal>
                    <ScrollReveal direction="right" delay={0.7} duration={0.8}>
                        <ServiceItem
                            icon={<FiBox className="text-white text-xl" />}
                            title={tString('services.items.volume.title')}
                            description={tArray('services.items.volume.description')}
                        />
                    </ScrollReveal>
                    <ScrollReveal direction="right" delay={0.8} duration={0.8}>
                        <ServiceItem
                            icon={<FiTool className="text-white text-xl" />}
                            title={tString('services.items.rental.title')}
                            description={tArray('services.items.rental.description')}
                        />
                    </ScrollReveal>
                </div>
            </div>
        </section>
    );
};

export default Services;
